import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import {
  Menu,
  Grid,
  Dropdown,
  Card,
  Divider,
  Avatar,
  Row,
  Col,
  Tag,
  Modal,
  Form,
  Input,
  Space,
  Button,
  message,
} from "antd";
import IntlMessage from "../util-components/IntlMessage";
import Icon from "../util-components/Icon";
import navigationConfig from "configs/NavigationKasirConfig";
import navigationAllConfig from "configs/NavigationAdminAllConfig";
import axios from "axios";
import { env } from "configs/EnvironmentConfig";

import { connect } from "react-redux";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import utils from "utils";
import { onMobileNavToggle } from "redux/actions/Theme";
import {
  UserOutlined,
  PoweroffOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { handleGet, handlePost } from "redux/actions/baseAction";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setClosing } from "redux/actions/kasir/transaction.action";
import { handleEmpty, rulesGeneral } from "helpers/general_helper";
import ButtonFormHelper from "helpers/button_form_helper";
import { isMobile, isAndroid, isTablet } from "react-device-detect";

require("moment-countdown");

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

// Consume Dropdown Menu props instead of forwarding them to Card.
const CashierOverlay = ({ children }) => <div>{children}</div>;

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const [stnk, setStnk] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loadingClosing, setLoadingClosing] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [passEdit, setPassEdit] = useState(false);
  const [l, setl] = useState("");
  const [dataProfile, setDataProfile] = useState(null);

  const { closeCashier } = useSelector(
    (state) => state.transactionCashierReducer
  );
  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
  } = props;
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");

  const isKasirOpen = closeCashier === false;

  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };

  const getData = () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get(env.API + "/admin/auth/user", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        const data = res.data.data.role.permissions;
        data.forEach((d) => {
          if (d === "MANAGE_STNK") {
            setStnk(true);
          }
        });
      })
      .catch((e) => {});
  };

  useEffect(() => {
    getData();
    handleProfile();
  }, []);

  const handleProfile = () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    handleGet("pos/pos/cashier/profile", (res) => {
      setDataProfile(res);
    });
  };

  useEffect(() => {
    if (isSetting && dataProfile) {
      form.setFieldsValue({ name: dataProfile.name });
    }
  }, [isSetting, dataProfile]);

  const handleClosing = () => {
    console.log("[KASIR] handleClosing dipanggil", {
      closeCashier,
      isKasirOpen,
      loadingClosing,
      next: isKasirOpen ? "CLOSE" : "OPEN",
    });
    if (loadingClosing) {
      console.warn("[KASIR] Request sebelumnya masih berjalan");
      return;
    }
    setLoadingClosing(true);
    const next = isKasirOpen ? "CLOSE" : "OPEN";
    console.log("[KASIR] Mengirim status ke API", next);
    handlePost("pos/pos/cashier/location/status", { status: next }, (datum, isSuccess) => {
      console.log("[KASIR] Respons API status", { datum, isSuccess, next });
      setLoadingClosing(false);
      if (!isSuccess) {
        message.error("Gagal mengubah status kasir. Silakan coba lagi.");
        return;
      }
      localStorage.setItem("statusClosing", next);
      if (next === "CLOSE") {
        localStorage.setItem("timeClosing", moment().format("YYYY-MM-DD HH:mm"));
      } else {
        localStorage.removeItem("timeClosing");
      }
      // Reducer convention: true means the cashier is open, false means closed.
      dispatch(setClosing(next === "OPEN"));
      setVisible(false);
      // Recalculate sidebar permissions after the server confirms the change.
      // Opening the cashier should take the user straight to transactions.
      if (next === "OPEN") {
        window.location.href = "/kasir/transaksi";
      } else {
        const token = localStorage.getItem("token");
        const logout = () => {
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          localStorage.removeItem("statusClosing");
          localStorage.removeItem("timeClosing");
          window.location.href = "/auth/login";
        };

        axios
          .post(
            env.API + "/user/auth/logout",
            {},
            { headers: { Authorization: "Bearer " + token } }
          )
          .then(logout)
          .catch(logout);
      }
    }, false);
  };

  const confirmClosing = (e) => {
    console.log("[KASIR] Klik menu buka/tutup", {
      closeCashier,
      isKasirOpen,
      loadingClosing,
    });
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (loadingClosing) return;
    const isOpen = isKasirOpen;

    // Close the profile dropdown first so the confirmation dialog has a clean backdrop.
    setVisible(false);
    setTimeout(() => Modal.confirm({
      title: isOpen ? "Tutup Kasir?" : "Buka Kasir?",
      content: isOpen
        ? "Pastikan tidak ada transaksi yang sedang berjalan."
        : "Kasir akan dibuka kembali.",
      okText: "Ya",
      cancelText: "Batal",
      centered: true,
      okButtonProps: {
        style: {
          backgroundColor: isOpen ? "#ff4d4f" : "#52c41a",
          borderColor: isOpen ? "#ff4d4f" : "#52c41a",
        },
      },
      onOk: () => {
        console.log("[KASIR] Konfirmasi Ya ditekan");
        handleClosing();
      },
    }), 0);
  };

  let durationStorage = localStorage.getItem("timeClosing")
    ? moment().countdown(localStorage.getItem("timeClosing"))
    : null;
  let hoursStorage = durationStorage ? durationStorage.hours : 0;
  let minutesStorage = durationStorage ? durationStorage.minutes : 0;

  let durasi = `${minutesStorage} Menit`;
  if (Number(hoursStorage) > 0) {
    durasi = `${hoursStorage} Jam ${minutesStorage} Menit`;
  }

  const handleSubmitProfile = (val) => {};

  return (
    <>
      <Menu
        theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
        mode="inline"
        style={{ height: "100%", borderRight: 0 }}
        defaultSelectedKeys={[routeInfo?.key]}
        defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
        className={hideGroupTitle ? "hide-group-title" : ""}
      >
        {navigationConfig.map((menu) => {
          let isDisabled = false;
          if ((menu.key === "transaksi" || menu.key === "top-up-and-billing") && !isKasirOpen) {
            isDisabled = true;
          }
          const menuTitle = menu.key === "closing"
            ? (isKasirOpen ? "Kasir Buka" : "Kasir Tutup")
            : menu.title;
          return menu.submenu.length > 0 ? (
            <Menu.ItemGroup key={menu.key} title={menu.title}>
              {menu.submenu.map((subMenuFirst) =>
                subMenuFirst.submenu.length > 0 ? (
                  <SubMenu
                    icon={
                      subMenuFirst.icon ? (
                        <Icon type={subMenuFirst?.icon} />
                      ) : null
                    }
                    key={subMenuFirst.key}
                    title={subMenuFirst.title}
                  >
                    {subMenuFirst.submenu.map((subMenuSecond) => (
                      <Menu.Item key={subMenuSecond.key}>
                        {subMenuSecond.icon ? (
                          <Icon type={subMenuSecond?.icon} />
                        ) : null}
                        <span>{subMenuSecond.title}</span>
                        <Link
                          onClick={() => closeMobileNav()}
                          to={subMenuSecond.path}
                        />
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item key={subMenuFirst.key}>
                    {subMenuFirst.icon ? (
                      <Icon type={subMenuFirst.icon} />
                    ) : null}
                    <span>{subMenuFirst.title}</span>
                    <Link
                      onClick={() => closeMobileNav()}
                      to={subMenuFirst.path}
                    />
                  </Menu.Item>
                )
              )}
            </Menu.ItemGroup>
          ) : (
            <Menu.Item
              key={menu.key}
              disabled={isDisabled}
              onClick={() => {
                if (menu.key === "closing") {
                  setVisible(!visible);
                }
              }}
            >
              {menu.icon ? <Icon type={menu?.icon} /> : null}
              <span style={{ fontWeight: "bold" }}>&nbsp;{menuTitle}</span>
              {menu.path ? (
                <Link onClick={() => closeMobileNav()} to={menu.path} />
              ) : null}
            </Menu.Item>
          );
        })}

        <Menu.ItemGroup
          style={{
            marginLeft: "32px",
            marginTop: "20px",
            bottom: "0",
            cursor: "context-menu",
          }}
        >
          <Dropdown
            placement="topRight"
            visible={visible && !isSetting}
            onVisibleChange={(v) => {
              if (!isSetting) setVisible(v);
            }}
            overlayStyle={{ width: "30%" }}
            overlay={
              <CashierOverlay>
              <Card
                style={{ padding: "20px" }}
                title={
                  <div>
                    <Row>
                      <Col md={4}>
                        <Avatar
                          style={{
                            color: "white",
                            background: "#363A4E",
                          }}
                          shape="circle"
                        >
                          <strong>
                            {dataProfile && dataProfile.name
                              ? dataProfile.name[0]
                              : "X"}
                          </strong>
                        </Avatar>
                      </Col>
                      <Col style={{ marginLeft: "10px" }}>
                        <strong>
                          {dataProfile && dataProfile.name
                            ? dataProfile.name
                            : "-"}
                        </strong>
                        <br />
                        <span style={{ color: "#2C2D30" }}>
                          {dataProfile && dataProfile.location
                            ? dataProfile.location.name
                            : "-"}
                        </span>
                      </Col>
                      <Col md={24} style={{ marginTop: "10px" }}>
                        <Row align="space-between">
                          <Col>
                            <Tag
                              style={{
                                backgroundColor: isKasirOpen
                                  ? "#E8F4EE"
                                  : "white",
                                color: isKasirOpen ? "#04990A" : "red",
                                fontWeight: "bold",
                              }}
                            >
                              Kasir {isKasirOpen ? "Buka" : "Tutup"}
                            </Tag>
                          </Col>
                          <p style={{ fontWeight: "bold" }}>
                            {!isKasirOpen && durasi}
                          </p>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                }
              >
                <Divider />
                <Button
                  type="link"
                  block
                  style={{
                    color: isKasirOpen ? "red" : "green",
                    cursor: "pointer",
                    textAlign: "left",
                    padding: 0,
                    height: "auto",
                  }}
                  onMouseDown={(event) => {
                    // Dropdown otherwise closes on the press event before click fires.
                    event.stopPropagation();
                    console.log("[KASIR] MouseDown tombol buka/tutup");
                  }}
                  onMouseUp={(event) => event.stopPropagation()}
                  onClick={(event) => {
                    event.stopPropagation();
                    console.log("[KASIR] Tombol buka/tutup diklik");
                    confirmClosing(event);
                  }}
                >
                  <PoweroffOutlined />{" "}
                  {isKasirOpen ? "Tutup" : "Buka"} Kasir{" "}
                  {loadingClosing && (
                    <span style={{ float: "right", color: "black" }}>
                      Mohon Tunggu ...
                    </span>
                  )}
                </Button>
                <br />
                <div
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setVisible(false);
                    setIsSetting(true);
                  }}
                >
                  <SettingOutlined /> Pengaturan
                </div>
              </Card>
              </CashierOverlay>
            }
            trigger={["click"]}
          >
            <UserOutlined
              style={{ color: "transparent", cursor: "pointer" }}
            />
          </Dropdown>
        </Menu.ItemGroup>
      </Menu>

      <Modal
        centered
        title={`Pengaturan`}
        visible={isSetting}
        closable={true}
        destroyOnClose={true}
        maskClosable={false}
        footer={null}
        onCancel={(e) => {
          setIsSetting(false);
          setVisible(false);
        }}
      >
        <Form
          form={form}
          initialValues={{ name: dataProfile?.name }}
          layout="vertical"
          onFinish={handleSubmitProfile}
          preserve={false}
          onChange={(e) => {}}
        >
          <Form.Item
            hasFeedback
            placeholder="Masukan nama kasir"
            label="Nama"
            name="name"
            rules={rulesGeneral()}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hasFeedback
            tooltip={
              <>
                minimal 8 karakter <br />
                maksimal 30 karakter <br />
                minimal 1 huruf besar <br />
                minimal 1 huruf kecil <br />
                minimal 1 angka <br />
                minimal 1 spesial karakter <br />
              </>
            }
            name="password"
            label="Password Baru"
            rules={[
              {
                pattern: new RegExp(
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/
                ),
                message:
                  "format salah, klik ikon tanda tanya untuk melihat format",
              },
            ]}
          >
            <Input.Password
              placeholder="Kosongkan Apabila Tidak Akan Diubah"
              onChange={(e) => {
                setl(e.target.value);
                setPassEdit(handleEmpty(e.target.value));
              }}
            />
          </Form.Item>
          <Form.Item
            hasFeedback
            tooltip={
              <>
                minimal 8 karakter <br />
                maksimal 30 karakter <br />
                minimal 1 huruf besar <br />
                minimal 1 huruf kecil <br />
                minimal 1 angka <br />
                minimal 1 spesial karakter <br />
              </>
            }
            name="password_confirmation"
            label="Konfirmasi Password Baru"
            rules={[
              {
                required: passEdit,
                message: "Tidak Boleh Kosong",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Password Tidak Sama"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Kosongkan Apabila Tidak Akan Diubah" />
          </Form.Item>
          <Divider />
          <Row justify="end" gutter={4}>
            <Space>
              <Button
                size="small"
                htmlType="button"
                style={{
                  border: "1px solid #3699FF",
                  color: "#3699FF",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  setIsSetting(false);
                  setVisible(false);
                }}
              >
                Batal
              </Button>
              <Button
                size="small"
                htmlType="submit"
                style={{
                  backgroundColor: "#3699FF",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                Simpan Perubahan
              </Button>
            </Space>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization } = props;
  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon type={menu?.icon} /> : null}
                <span>{menu.title}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  popupClassName="top-nav-menu"
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={subMenuFirst.title}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>{subMenuSecond.title}</span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{subMenuFirst.title}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{menu?.title}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
